import { FC } from 'react';
import Modal from 'components/layouts/modal';
import { Role } from 'types/role';

interface ViewRoleProps {
  open: boolean;
  setOpen: (val: boolean) => void;
  role?: Role;
}

const ViewRole: FC<ViewRoleProps> = ({ open, setOpen, role }) => {
  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title={role?.name || 'Role'}
      description={role?.description || undefined}
      size="4xl"
      hideActions
    >
      <div className="space-y-4">
        <div>
          <h4 className="text-sm font-semibold text-gray-700">Permissions</h4>
          <div className="mt-2 flex flex-wrap gap-2">
            {role?.permissions?.length ? (
              role.permissions.map(perm => (
                <span
                  key={perm}
                  className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-700 ring-1 ring-inset ring-gray-500/10"
                >
                  {perm}
                </span>
              ))
            ) : (
              <p className="text-sm text-gray-500">No permissions assigned</p>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ViewRole;
